/**
 * Main Application Component with React Router configuration
 * Validates: Requirements 9.4
 */

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { Loader2 } from 'lucide-react';
import { ErrorBoundary } from './features/student-viewer/components/ErrorBoundary/ErrorBoundary';

import './assets/style.css';
import './assets/viewer.css';

// Lazy load page components for code splitting（default export で解決）
const LecturePage = lazy(() => import('./features/student-viewer/pages/LecturePage'));

/**
 * Global loading fallback component
 */
function LoadingFallback() {
  return (
    <div
      className="flex min-h-screen items-center justify-center"
      style={{ background: 'var(--background-color)' }}
    >
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-10 w-10 animate-spin text-blue-500" />
        <p className="text-gray-600">読み込み中...</p>
      </div>
    </div>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            {/* Unified lecture page route - handles both live and archive */}
            <Route
              path="/:tenantSlug/lecture/:internalId"
              element={<LecturePage />}
            />
            
            {/* Legacy routes redirect to unified page */}
            <Route
              path="/:tenantSlug/lecture/:lectureId/live"
              element={<Navigate to="../" replace />}
            />
            <Route
              path="/:tenantSlug/lecture/:lectureId/archive"
              element={<Navigate to="../" replace />}
            />
            
            {/* Fallback route */}
            <Route
              path="*"
              element={
                <div className="flex min-h-screen items-center justify-center bg-gray-50">
                  <p className="text-gray-600">ページが見つかりません</p>
                </div>
              }
            />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
